import React, { FC, PropsWithChildren } from 'react';
import { getMessage } from './util';
import { FileUploadFailureMessageProps } from '../../../../types';

export const SingleMessage: FC<PropsWithChildren<FileUploadFailureMessageProps>> = props => {
	const { failedFileIds, failuresByFileId } = props;

	return <div>{getMessage(failedFileIds, failuresByFileId)}</div>;
};
